module.exports = __webpack_public_path__ + "img/selected3-min.be98a032.png";